module.exports = __webpack_public_path__ + "img/phone.5ed22673.png";